import React from 'react';
import { AspectScoreWithDateRange } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoresList.helpers';
import { SelectedDateRange } from 'types/misc';
import { AspectScore, AspectScores } from 'types/blockwiseScores';

interface ScoreOverTimeByAreaContextInterface {
  allAspectScores: AspectScores[];
  allAspectScoresWithDateRange: AspectScoreWithDateRange[];
  parentDivisionAspectScoresWithDateRange: AspectScoreWithDateRange[];
  selectedDateRange: SelectedDateRange;
  selectedAspectScore: AspectScore;
}

export const ScoreOverTimeByAreaContext = React.createContext<ScoreOverTimeByAreaContextInterface>(
  {} as ScoreOverTimeByAreaContextInterface,
);
